import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import apihost from "../../services/apihostname";

//Import module Modal
import Modal from "react-bootstrap/Modal";

// Import module Services
import farmerService from "../../services/farmer.service";
// import AssocService from "../../services/assoc.service";
import authService from "../../services/auth.service";
import uploadService from "../../services/uploadfile.service";
import apihostname from "../../services/apihostname";

// Import Form
import { Form } from "react-bootstrap";

// Import module for datePicker
// import dayjs from "dayjs";
// import { WatDatePicker } from "thaidatepicker-react";

//Import ConfirmAlert
// import { confirmAlert } from "react-confirm-alert";

//Import loading
import LoadingAlert from "../../components/LoadingAlert";
import { toast } from "react-toastify";

//Import WebCam
// import Webcam from "../Member/Webcam";

//Import farmer.css
import "../Farmer/farmer.css";

// const valid = {
//   display: "block",
//   width: "100%",
//   padding: "0.375rem 0.75rem",
//   fontSize: "1rem",
//   fontWeight: 400,
//   lineHeight: 1.5,
//   color: "#212529",
//   backgroundColor: "#fff",
//   backgroundClip: "padding-box",
//   border: "1px solid #ced4da",
//   appearance: "none",
//   borderRadius: "0.25rem",
//   transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
// };

// const invalid = {
//   display: "block",
//   width: "100%",
//   padding: "0.375rem 0 0.375rem",
//   fontSize: "1rem",
//   fontWeight: 400,
//   lineHeight: 1.5,
//   color: "#212529",
//   backgroundColor: "#fff",
//   backgroundClip: "padding-box",
//   border: "1px solid #dc3545",
//   appearance: "none",
//   borderRadius: "0.25rem",
//   transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
//   paddingRight: "calc(1.5em + 0.75rem)",
//   backgroundImage:
//     'url(\'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="%23dc3545"%3e%3ccircle cx="6" cy="6" r="4.5"/%3e%3cpath stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/%3e%3ccircle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/%3e%3c/svg%3e\')',
//   backgroundRepeat: "no-repeat",
//   backgroundPosition: "right calc(0.375em + 0.1875rem) center",
//   backgroundSize: "calc(0.75em + 0.375rem) calc(0.75em + 0.375rem)",
// };

function ModalViewMember(props) {
  // const [loadAlert, setLoadAlert] = useState(false);
  const [member, setMember] = useState({});
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const user = authService.getCurrentUser();

  const handleClose = () => {
    props.hidden(false);
    setFiles([]);
    initialForm();
    // setMember({});
    // props.data = {};
  };

  const initialForm = () => {
    // setSelectedDate("");
    // setMember({});
    // setLoadAlert(false);
  };

  const listMemberFile = (member) => {
    // console.log(member);
    setLoading(true);
    uploadService
      .listAssocMemberFile(member)
      .then((response) => {
        // console.log(response.data.data);
        setFiles(response.data.data);
      })
      .catch((err) => toast.error(err))
      .finally(() => {
        setLoading(false);
      });
  };

  const getFileExtStyle = (file_ext) => {
    console.log(file_ext);
    if (file_ext === "pdf") {
      return "red";
    } else if (
      file_ext === "xls" ||
      file_ext === "xlsx" ||
      file_ext === "csv"
    ) {
      return "green";
    } else if (file_ext === "doc" || file_ext === "docx") {
      return "blue";
    } else {
      return "purple";
    }
  };

  useEffect(() => {
    setMember({});
    setImage({});
    listMemberFile(props.data);
    console.log(props.data);
    if (props.data.cardid) {
      // let statusmaster = "";
      farmerService.getFarmerById(props.data.cardid).then((data) => {
        if (data.data.success) {
          const status = data.data.farmer.status ? "มีชีวิต" : "เสียชีวิต";
          const statusmaster =
            props.data.statusmaster == "head" ? "หัวหน้ากลุ่ม" : "สมาชิก";

          let memberstatus = "";
          if (props.data.farmerstatus == "goodid") {
            memberstatus = "ส่งปกติ";
          } else if (props.data.farmerstatus == "badid") {
            memberstatus = "ไม่มีการส่ง";
          } else if (props.data.farmerstatus == "no3yr") {
            memberstatus = "ขาดส่ง";
          } else {
            memberstatus = "รอตรวจสอบ";
          }
          const birthdate = new Date(data.data.farmer.birth_date);
          // console.log(birthdate);
          if (data.data.farmer.farmer_image) {
            setImage({
              preview:
                apihost + "/images/farmer/" + data.data.farmer.farmer_image,
            });
          }
          const signdate = new Date(props.data.createdat);

          setMember({
            ...data.data.farmer,
            associd: props.data.associd,
            assocname: props.data.assocname,
            cardid: props.data.cardid,
            membercode: props.data.membercode,
            membercardid: props.data.farmercardid,
            memberstatus: memberstatus,
            statusmaster: statusmaster,
            statusmember: props.data.statusmember,
            statusapprove: props.data.statusapprove,
            createdate: signdate.toLocaleString("th-TH", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            status: status,
            birth_date: birthdate.toLocaleString("th-TH", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            pre_name: data.data.farmer.pre_name,
            prov: data.data.farmer.prov_namt,
            amp: data.data.farmer.amp_namt,
            tam: data.data.farmer.tam_namt,
          });
        } else {
          alert(data.data.message);
        }
      });
    }
  }, [props.data.cardid]);

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="md" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>ข้อมูลสมาชิก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* <h4>ข้อมูลการเป็นสมาชิก</h4> */}
            {/* {JSON.stringify(files)} */}
            <table className="table-bordered-striped align-center" mb="12">
              <tbody>
                {user.user.member_type !== 4 ? (
                  <tr>
                    <th scope="col">สมาคม</th>
                    <td scope="col">{member.assocname}</td>
                  </tr>
                ) : (
                  ""
                )}
                <tr>
                  <th>สมาชิก</th>
                  <td>
                    {(member.pre_name ? member.pre_name : member.pre_other) +
                      " " +
                      member.first_name +
                      " " +
                      member.last_name}
                  </td>
                </tr>
                <tr>
                  <th>จดทะเบียนชาวไร่</th>
                  <td>{member.createdate}</td>
                </tr>
                <tr>
                  <th>รหัสสมาชิก</th>
                  <td>{member.membercode}</td>
                </tr>
                <tr>
                  <th>สถานะ</th>
                  <td>
                    {member.statusmember + " [ " + member.statusapprove + " ] "}
                  </td>
                </tr>
                <tr>
                  <th>เอกสาร</th>
                  <td>
                    {files.length > 0
                      ? files.map((item, key) => {
                          let file_ext = item.split(".");
                          return (
                            <>
                              <span key={key}>
                                <a
                                  href={
                                    apihostname +
                                    "/uploads/associations/" +
                                    member.associd +
                                    "/" +
                                    member.cardid +
                                    "/" +
                                    item
                                  }
                                  download={item}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={`bi bi-filetype-${file_ext[1]} custom-icon-table `}
                                  style={{
                                    padding: ".375rem .75rem",
                                    fontSize: "1.5rem",
                                    color: getFileExtStyle(file_ext[1]),
                                  }}
                                ></a>
                              </span>
                            </>
                          );
                        })
                      : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <h4>ข้อมูลชาวไร่อ้อย</h4>
            <table className="table-bordered smooth align-left">
              <tbody>
                <tr>
                  <th scope="col">ข้อมูล</th>
                  <th scope="col">รายละเอียด</th>
                </tr>
                <tr>
                  <th>รูปภาพ</th>
                  <td>
                    {image.preview ? (
                      <div className="uploadpic">
                        <label htmlFor="upload-button">
                          <img
                            src={image.preview}
                            alt="No Image"
                            width="150"
                            height="150"
                          />
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <th>หมายเลขบัตรประชาชน</th>
                  <td>{member.cardid}</td>
                </tr>
                <tr>
                  <th>รหัสเกษตรกร</th>
                  <td>{member.membercardid}</td>
                </tr>
                <tr>
                  <th>สถานะการมีชีวิต</th>
                  <td>{member.status}</td>
                </tr>
                <tr>
                  <th>เกิดวันที่</th>
                  <td>{member.birth_date}</td>
                </tr>
                <tr>
                  <th>เพศ</th>
                  <td>{member.sex}</td>
                </tr>
                <tr>
                  <th>ที่อยู่</th>
                  <td>
                    {(member.address ? member.address : "") +
                      " " +
                      member.tam +
                      " " +
                      member.amp +
                      " " +
                      member.prov}
                  </td>
                </tr>
                <tr>
                  <th>โทร.</th>
                  <td>{member.tel}</td>
                </tr>
              </tbody>
            </table>
          </Form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalViewMember;

ModalViewMember.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  data: PropTypes.object,
  setdata: PropTypes.func,
  // memberid: PropTypes.number,
  userid: PropTypes.number,
};
// ModalViewMember.defaultProps = {
//   data: [{}],
// };
